import React, { useState } from "react";
import { CardElement, ElementsConsumer } from "@stripe/react-stripe-js";
import { injectIntl } from "react-intl";
import { ToastContainer, toast } from "react-toastify";
import Button from "../../../Button";
import styles from "./Form.styles.css";
import { finishCartCheckout, updateCartCheckout, updateCartCheckoutWithUser } from "../../../../api";
import Input from "../../../Input";
import Select, { components } from "react-select";
import Router from "next/router";

const Form = (props) => {
  const { intl } = props;
  const [isSending, setIsSending] = useState(false);
  const [countries, setCountries] = useState(
    props.countries.map((c) => ({ value: c.id, label: c.name }))
  );
  const [formData, _setFormData] = useState({
    address: props.address || "",
    firstName: props.firstName || "",
    lastName: props.lastName || "",
    nif: props.nif || "",
    mail: props.mail || "",
    phone: props.phone || "",
    postalCode: props.postalCode || "",
    country: props.country || "",
    locale: props.locale || "",
  });

  const setFormData = (key, value) => {
    _setFormData((f) => ({ ...f, [key]: value }));
  };

  const sessionCheckout = async (event, elements, stripe)=> {
    event.preventDefault();
    if (!stripe || !elements) return;
    console.log('sessionCheckout')
    if(props.user.token != null) {
      updateCartCheckoutWithUser({
        id: props.cart.id,
        totem: props.qrs,
        ...formData,
        country: new Number(formData.country)
      }, props.user).then((data) => {
        localStorage.removeItem('qrs')
        if( data.id !== ''){
          const result = stripe.redirectToCheckout({
            sessionId: data.id,
          });
        }else{
          Router.push(
            `/${props.locale}/${props.destination.rawId}/checkout?uuid=${props.cart.id}&success=true`
          );
        }
      }).catch((error) => {
  
      });
    } else {
      updateCartCheckout({
        id: props.cart.id,
        totem: props.qrs,
        ...formData,
        country: new Number(formData.country)
      }).then((data) => {
        localStorage.removeItem('qrs')
        if( data.id !== ''){
          const result = stripe.redirectToCheckout({
            sessionId: data.id,
          });
        }else{
          Router.push(
            `/${props.locale}/${props.destination.rawId}/checkout?uuid=${props.cart.id}&success=true`
          );
        }
      }).catch((error) => {
  
      });
    }
  }

  const onCardChange = (event) => {
    if (event.complete) {
      setFormData("postalCode", event.value.postalCode);
    }
  };

  const CARD_OPTIONS = {
    iconStyle: "solid",
    style: {
      base: {
        iconColor: "purple",
        fontWeight: 500,
        fontSize: "18px",
        fontFamily: "Montserrat",
        fontSmoothing: "antialiased",
      },
      invalid: {
        iconColor: "#ffc7ee",
        color: "#ffc7ee",
      },
    },
  };

  return (
    <ElementsConsumer>
      {({ elements, stripe }) => (
        <form
          className={styles.form}
          onSubmit={() => sessionCheckout(event, elements, stripe)}
        >
          <div className={styles.column}>
            <div className={styles.row}>
              <Input
                required
                onChange={(e) => {
                  const nameArray = e.target.value.split(" ");
                  const lastName = nameArray[nameArray.length - 1];
                  setFormData("firstName", nameArray[0]);
                  setFormData("lastName", lastName);
                }}
                placeholder={intl.formatMessage({
                  id: "checkout.form.name.placeholder",
                })}
              />
            </div>
            <div className={styles.row}>
              <Input
                required
                onChange={(e) => {
                  setFormData("nif", e.target.value);
                }}
                placeholder={intl.formatMessage({
                  id: "checkout.form.nif.placeholder",
                })}
              />
            </div>
            <div className={styles.row}>
              <Input
                required
                onChange={(e) => {
                  setFormData("phone", e.target.value);
                }}
                placeholder={intl.formatMessage({
                  id: "checkout.form.phone.placeholder",
                })}
              />
            </div>
          </div>
          <div className={styles.column}>
            <div className={styles.row}>
              <Input
                required
                onChange={(e) => {
                  setFormData("address", e.target.value);
                }}
                placeholder={intl.formatMessage({
                  id: "checkout.form.address.placeholder",
                })}
              />
            </div>
            <div className={styles.row}>
              <Input
                required
                onChange={(e) => {
                  setFormData("postalCode", e.target.value);
                }}
                placeholder={intl.formatMessage({
                  id: "checkout.form.postal-code.placeholder",
                })}
              />
            </div>
            <div className={styles.row}>
              <Select
                required
                isClearable
                isSearchable
                name="countries"
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary75: "rgba(196, 50, 190, 0.75);",
                    primary50: "rgba(196, 50, 190, 0.50);",
                    primary25: "rgba(196, 50, 190, 0.25);",
                    primary: "rgb(196, 50, 190)",
                  },
                })}
                placeholder={intl.formatMessage({
                  id: "checkout.form.country.placeholder",
                })}
                onChange={({ value }) => {
                  setFormData("country", value);
                }}
                options={countries}
              />
            </div>


          </div>
          <div className={styles.column}>
            <div className={styles.row}>
              <Input
                required
                onChange={(e) => {
                  setFormData("mail", e.target.value);
                }}
                placeholder={intl.formatMessage({
                  id: "checkout.form.mail.placeholder",
                })}
              />

            </div>
          </div>
          {/**

           <div className={styles.row}>
            <div className={styles.fakeInput}>
              <CardElement
                hide
                onChange={onCardChange}
                options={CARD_OPTIONS}
              />
            </div>
          </div>

           */}

          <div className={styles.row}>
            <div />
            <Button
              processing={isSending}
              label={intl.formatMessage({
                id: "checkout.form.request-payment-button",
              })}
              disabled={!stripe}
            />
          </div>
          <ToastContainer />
        </form>
      )}
    </ElementsConsumer>
  );
};

Form.defaultProps = {
  countries: [],
};

export default injectIntl(Form);
